import bind from 'bind-decorator'
import { appConfig } from 'config'
import { Debounce } from 'lodash-decorators/debounce'
import { Throttle } from 'lodash-decorators/throttle'
import { action, computed, IReactionDisposer, observable, reaction } from 'mobx'
import { routerStore } from 'stores/routerStore'
class CallToScrollStore {
  inactivityTimer: number = 0
  inactivityDuration: number = 6000
  disposer: IReactionDisposer

  @observable
  scrolledToBiographyBottom: boolean = false

  @observable
  showIcon: boolean = false

  @observable
  scrollIconSwitchBlocked: boolean = false

  constructor() {
    this.startTimerAfterScrollIsStopped = this.startTimerAfterScrollIsStopped.bind(
      this
    )
    this.stopTimerWhenScrolled = this.stopTimerWhenScrolled.bind(this)
    this.addListenersForScrollEvents()
    this.disposer = reaction(
      () => {
        return this.isBiography
      },
      (shouldShowIcon) => {
        if (shouldShowIcon) {
          this.resetInactivityTimer()
        } else {
          this.hideIconAndClearTimeout()
        }
      }
    )
  }

  @computed
  get isBiography() {
    if (!(appConfig.extraRoutes.length > 0)) {
      return false
    }

    return (
      !routerStore.location.pathname.includes(appConfig.contentUnitUrl) &&
      routerStore.location.pathname.includes('biografie')
    )
  }

  @bind
  addListenersForScrollEvents() {
    document.addEventListener(
      'scroll',
      this.startTimerAfterScrollIsStopped,
      true
    )
    document.addEventListener('scroll', this.stopTimerWhenScrolled, true)
  }

  @Debounce(2000)
  startTimerAfterScrollIsStopped() {
    this.resetInactivityTimer()
  }

  @bind
  @action
  setShowIcon(value: boolean) {
    this.showIcon = value
  }

  @bind
  resetInactivityTimer() {
    if (this.isBiography) {
      this.hideIconAndClearTimeout()
      this.showIconAfterTimeout()
    }
  }

  @bind
  showIconAfterTimeout() {
    if (this.scrolledToBiographyBottom) {
      return
    }
    this.inactivityTimer = window.setTimeout(
      () => this.setShowIcon(true),
      this.inactivityDuration
    )
  }

  @bind
  hideIconAndClearTimeout() {
    window.clearTimeout(this.inactivityTimer)
    if (this.showIcon) {
      this.setShowIcon(false)
    }
  }

  @Throttle(1000)
  stopTimerWhenScrolled() {
    this.hideIconAndClearTimeout()
  }

  handleAlertVisibility(position: number) {
    this.scrolledToBiographyBottom = position > 0.989
  }
}

export const callToScrollStore = new CallToScrollStore()
